import { I18n } from '@boschebike/ebds-js';
import { useContext } from 'react';
import { InternalEventLink, InternalNavigationLink, Page } from '../../components';
import { termsOfUseRoutes } from '../../config/router';
import { DxfIntegrationContext } from '../../context/dxfIntegrationContext';
import { LocalizationContext } from '../../context/localizationContext';
import { PlatformContext } from '../../context/platformContext';
import { interpolateContentToJSX } from '../../helpers';
import { onScroll } from '../../helpers/scroll';
import { useContent } from '../../hooks/use-content';
import { TermsOfUseUsAnnexOnePage } from './TermsOfUseUsAnnexOnePage';

export const TermsOfUsePage = () => {
  const content: I18n = useContent();
  const platformContext = useContext(PlatformContext);
  const localizationContext = useContext(LocalizationContext);
  const dxfIntegrationContext = useContext(DxfIntegrationContext);

  const contentKeyPage: string = content.t('portal.termsOfUse');
  const jsxContent: JSX.Element[] = interpolateContentToJSX(contentKeyPage, [
    {
      selector: 'default-link',
      element: InternalNavigationLink,
      elementProps: {
        href: dxfIntegrationContext.getInternalNavigationLink('default'),
        text: content.t('portal.termsOfUse.linkText'),
      },
    },
    {
      selector: 'annex-scroller',
      element: InternalEventLink,
      elementProps: {
        onClickEvent: onScroll(contentKeyPage, 'usa'),
        text: content.t('portal.termsOfUse.annex'),
      },
    },
    {
      selector: 'annex-link',
      element: TermsOfUseUsAnnexOnePage,
      elementProps: {
        lang: localizationContext.locale,
      },
    },
    {
      selector: 'default-link-us',
      element: InternalNavigationLink,
      elementProps: {
        href: dxfIntegrationContext.getInternalNavigationLink('us'),
        text: content.t('portal.termsOfUse.linkText'),
      },
    },
  ]);

  return (
    <Page
      links={termsOfUseRoutes(content, { isDPASupported: dxfIntegrationContext.isDPASupported, isDXF: platformContext.isDXF })}
      enforcedTabId="100"
    >
      {...jsxContent}
    </Page>
  );
};
